export default {
	loading: "Loading agenda...",
	unavailable: "Agenda unavailable",
	unavailableHint:
		"This link may have expired or the agenda was disabled by the temple.",
	empty: "No rituals published at the moment.",
	upcoming: "Upcoming rituals",
	tabs: {
		calendar: "Calendar",
		info: "More information",
	},
	info: {
		about: "About us",
		address: "Address",
		contact: "Contact",
		phone: "Phone",
		whatsapp: "WhatsApp",
		email: "Email",
		social: "Social media",
	},
	reserve: "Reserve a spot",
	full: "Full",
	dialog: {
		title: "Reserve a spot",
		subtitle: "Fill in your details to reserve for this ritual.",
		name: "Your name",
		phone: "Phone",
		email: "Email",
		notes: "Note (optional)",
		photo: {
			label: "Photo",
			capture: "Take photo",
			retake: "Retake",
		},
		consent: "I authorize the temple to use my contact details for this reservation.",
		consentWithPhoto:
			"I authorize the temple to use my contact details and the photo just taken for this reservation.",
		submit: "Send reservation",
		cancel: "Cancel",
	},
	validation: {
		nameRequired: "Enter your name",
		phoneRequired: "Enter your phone",
		emailRequired: "Enter your email",
		emailInvalid: "Invalid email",
		consentRequired: "You must authorize to reserve",
		photoRequired: "Take a photo to complete the reservation",
	},
	success: {
		title: "Reservation received!",
		message: "We received your reservation. The temple will review it and get back to you.",
		close: "Close",
	},
	error: "We couldn't send your reservation. Please try again.",
	poweredBy: "Agenda by ORI",
	tracking: {
		title: "Your reservation",
		statusPendingConfirmation: "Confirm your reservation",
		statusPendingReview: "Awaiting temple review",
		statusApproved: "Reservation confirmed",
		statusRejected: "Reservation rejected",
		statusCancelled: "Reservation cancelled",
		confirmHint: "Click below to confirm your attendance at this ritual.",
		reviewHint: "We received your confirmation. The temple will review it and get in touch.",
		approvedHint: "All set! Your attendance is confirmed.",
		confirm: "Confirm reservation",
		cancel: "Cancel reservation",
		confirmed: "Reservation confirmed!",
		cancelled: "Reservation cancelled.",
		error: "Could not complete. Please try again.",
		notFound: "Reservation not found.",
	},
};
